// Path: ./src/app/components/ImageWithModal/index.tsx
import {
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { GfFlyerItemImage } from "@swagger/typescript-fetch-goflyer";
import { makeStoreDisplayName } from "../../../utils/dtoUtil/makeStoreDisplayName";
import { LargeImage, ModalOverlay, SmallImage } from "./styled";

/**
 * React functional component representing an image with modal functionality.
 * Displays either a small image with optional text or a card with detailed information.
 * @param {object} props - Component properties.
 * @param {string} props.smallImageUrl - The URL of the small-sized image.
 * @param {string} props.largeImageUrl - The URL of the large-sized image.
 * @param {GfFlyerItemImage} props.data -GfFlyerItemImage.
 * @param {string} props.alt - Alternate text for the image.
 * @returns {JSX.Element} The ImageWithModal component.
 */
const ImageWidthModal: React.FC<{
  smallImageUrl: string;
  largeImageUrl: string;
  data?: GfFlyerItemImage;
  alt: string;
}> = ({ smallImageUrl, largeImageUrl, alt, data }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleImageClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {data?.id ? (
        <Card sx={{ width: 200, cursor: "pointer" }} onClick={handleImageClick}>
          <CardMedia
            sx={{ height: 180, width: 200 }}
            image={data?.gfImage.src}
            title="green iguana"
          />
          <CardContent>
            <Typography gutterBottom variant="body2" component="div" mb={2}>
              {data?.gfImage.alt}
            </Typography>

            <Typography variant="body2" color="text.secondary">
              {data?.createdAt?.toDateString()}
            </Typography>
            {data?.store?.id ? (
              <Typography variant="body2" color="text.secondary">
                {makeStoreDisplayName(data.store)}
              </Typography>
            ) : (
              <></>
            )}
          </CardContent>
        </Card>
      ) : (
        <>
          <SmallImage
            src={smallImageUrl}
            alt="Small Image"
            onClick={handleImageClick}
          />
          {alt ? <div>{alt}</div> : <></>}
        </>
      )}

      {isModalOpen && (
        <ModalOverlay>
          <Stack width={"100%"} alignItems={"flex-end"}>
            <IconButton
              sx={{ color: "white", width: "50px" }}
              onClick={handleCloseModal}
            >
              <CancelIcon />
            </IconButton>
          </Stack>
          <LargeImage src={largeImageUrl} alt="Large Image" />
        </ModalOverlay>
      )}
    </>
  );
};

export default ImageWidthModal;
